module.exports = __webpack_public_path__ + "static/media/havingfundaticra24.b13627c7.jpeg";